<template>
<div class="processing" >
  <div class=" processing_content container">
    <h1>Processing</h1>
    <p>
      Téléchargez les exécutables correspondant à votre système d'exploitation ou bien le code source (.zip). Pour ce dernier Processing est nécéssaire.
    </p>
    <div class="row">
      <div class="col-md-6">
        <video autoplay loop>
          <source src="/static/video/processing.mp4" type="video/mp4">
        </video>
      </div>
      <div class="download_processing col-md-6">
        <div class="download_block">
          <p>
            <a href="/static/processing/LogoImacExecutableWindows.zip" download="LogoImacExecutableWindows">Windows (.zip)</a>
          </p>
        </div>
        <div class="download_block">
          <p>
            <a href="/static/processing/LogoImacExecutableLinux.zip" download="LogoImacExecutableLinux">Linux (.zip)</a>
          </p>
        </div>
        <div class="download_block">
          <p>
            <a href="/static/processing/LogoImacSource.zip" download="LogoImacSource">Source (.zip)</a>
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
</template>
<script>
  export default {
    name: 'processing'   
  }
</script>
<style lang="scss">
  /*FONTS
  **
  */
  @font-face {
    font-family: 'Poppins-Regular';
    src: url('../assets/fonts/Poppins-Regular.ttf');
  }

  .processing h1, 
  .processing h2, 
  .processing h3, 
  .processing p {font-family: 'Poppins-Regular';}

  .processing p {font-size: 16px}

  .processing{ 
    height: 100vh;
    background-image: url("../assets/bkg/gplaypattern.png"); 
  }

  .processing_content{ 
    height: 100%;
    background: rgba(255,255,255,0.4); 
    padding-bottom: 20px;
  }

  .download_processing { padding-top: 100px; }

  .download_processing p { 
    padding-top: 10px;
    padding-bottom: 20px; 
  }

  a  {
    color: #333;
    text-decoration: none;
  }
  a:hover {
    color:#595959;
    text-decoration: none;
  }

  a:focus {
    color:#808080;
    text-decoration: none;
  }

</style>



// WEBPACK FOOTER //
// Processing.vue?a08ec70e